const toggleTabIndexOnScroll = (relatedProductsElement) => {
    const relatedProductsList = relatedProductsElement.querySelector('.js-related-products-list');
    const sliderController = relatedProductsElement.querySelector('.p-slider-controller');

    if (sliderController && relatedProductsList) {
        // ページロード時に初回チェック
        const updateTabIndex = () => {
            if (!sliderController.hasAttribute('hidden')) {
                relatedProductsList.setAttribute('tabindex', '0');
            } else {
                relatedProductsList.removeAttribute('tabindex');
            }
        };

        updateTabIndex();

        // 属性変更の監視
        const observerCallback = (mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.attributeName === 'hidden') {
                    updateTabIndex();
                }
            });
        };

        const observer = new MutationObserver(observerCallback);

        observer.observe(sliderController, {attributes: true});
    }
};

export default () => {
    const relatedProducts = document.querySelectorAll('.js-related-products');

    relatedProducts.forEach((relatedProductsElement) => {
        toggleTabIndexOnScroll(relatedProductsElement);
    });
};
